import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function Home() {
   const navigate = useNavigate();
  useEffect(() => {
    const toggle = document.querySelector(".menu-toggle");
    const sidebar = document.querySelector(".sidebar");
    const overlay = document.querySelector(".overlay");
    const closeBtn = document.querySelector(".close-btn");

    function closeMenu() {
      sidebar.classList.remove("active");
      overlay.classList.remove("active");
      document.body.classList.remove("sidebar-open");
    }

    toggle?.addEventListener("click", () => {
      sidebar.classList.add("active");
      overlay.classList.add("active");
      document.body.classList.add("sidebar-open");
    });

    closeBtn?.addEventListener("click", closeMenu);
    overlay?.addEventListener("click", closeMenu);

    return () => {
      toggle?.removeEventListener("click", () => {});
      closeBtn?.removeEventListener("click", closeMenu);
      overlay?.removeEventListener("click", closeMenu);
    };
  }, []);

  return (
    <div>

      {/* Hero Section */}
      <section className="hero">
        <header className="hero-header">
          <nav className="nav">
            <ul className="menu">
              <li><a href="#services">Services</a></li>
              <li><a href="#casestudies">Courses</a></li>
              <li><a href="#contact">Contact</a></li>
            </ul>

            <div className="logo">Vidify</div>
            <a className="btn-outline" href="#connect" onClick={() => navigate("/signup")}
            style={{ cursor: "pointer" }} >Join for free</a>
          </nav>
        </header>

        <aside className="sidebar">
          <button className="close-btn">&times;</button>
          <ul className="sidebar-menu">
            <li><a href="#services">Services</a></li>
            <li><a href="#casestudies">Case Studies</a></li>
            <li><a href="#contact">Contact</a></li>
          </ul>
        </aside>

        <div className="overlay"></div>

        <div className="hero-content">
          <div className="hero-txt-area">
            <div className="hero-title-wrap">
              <img src="/assets/images/vector3143-fs7o.svg" className="hex" alt=""/>
              <h1 className="hero-title">
                <span className="t-dark">Bu </span>
                <span className="t-light"> ild Real Skills,</span>
                <div className="cl"></div>
                <span className="t-light-2nd">Shape Your Future</span>
              </h1>
            </div>

            <p className="hero-desc">
              Learn from expert-designed courses that turn knowledge into practical ability. 
              Study at your own pace, track your progress, and gain the confidence you need to succeed in academics, career, and beyond.
            </p>
          </div>
          <a className="btn-primary" href="#connect">Connect Now</a>
        </div>
      </section>

      {/* Banner Images */}
      <div className="banner-Sep-Section">
        <img src="/assets/images/banner_image_slide_1.png" alt="Banner"/>
        <img src="/assets/images/banner_image_slide_2.png" alt="Banner"/>
        <img src="/assets/images/banner_image_slide_3.png" alt="Banner"/>
        <img src="/assets/images/banner_image_slide_4.png" alt="Banner"/>
      </div>

      {/* Do What Section */}
      <section className="trulysoundsgood-container">
        <div className="trulysoundsgood-thq-trulysoundsgood-elm">

          <div className="trulysoundsgood-thq-group16-lft">
            <h2 className="trulysoundsgood-thq-text-elm2">
              <span>Do What TrulySounds</span> <span>Good</span>
            </h2>
            <img
              src="/assets/images/vector3121-uh5p.svg"
              alt=""
              className="trulysoundsgood-thq-vector-elm"
            />
            <p className="trulysoundsgood-thq-text-elm1">
              Do what truly sounds good by following what feels comfortable,
              simple, and positive, helping you move forward with ease and
              confidence.
            </p>
          </div>

          <div className="trulysoundsgood-thq-frame1000001958-elm">
            <article className="trulysoundsgood-card">
              <img
                src="/assets/images/rectangle93121-sj5-400h.png"
                alt=""
              />
              <div className="card-content">
                <h3>Craft Engaging Content</h3>
                <div className="card-row">
                  <p>
                    Craft engaging content that captures attention, communicates clearly, and keeps your audience
                    interested from start to finish.
                  </p>
                  <div className="trulysoundsgood-crd-arrow">
                    <img src="/assets/images/right_arrow.svg" alt=""/>
                  </div>
                </div>
              </div>
            </article>

            <article className="trulysoundsgood-card">
              <img
                src="/assets/images/rectangle93121-a6q-400h.png"
                alt=""
              />
              <div className="card-content">
                <h3>Grow Your Business</h3>
                <div className="card-row">
                  <p>
                    Sell more products with smarter marketing, improved customer engagement, and clear strategies that simplify growth.
                  </p>
                  <div className="trulysoundsgood-crd-arrow">
                    <img src="/assets/images/right_arrow.svg" alt=""/>
                  </div>
                </div>
              </div>
            </article>

          </div>
        </div>
      </section>

      {/* Our Work Section */}
      <section className="ourwork-section">
        <div class="ourwork-inner">

        <div class="ourwork-heading">
          <h2>Hear From Users<br/>Who Trust Our Work</h2>
          <img src="/assets/images/vector3121-uh5p.svg" alt=""/>
        </div>


        <div class="ourwork-grid">
          <div class="ourwork-card ourwork-card-image ourwork-card-image1">
            <img src="assets/images/rectangle93121-j1qf-500h.png" alt=""/>
          </div>

          <div class="ourwork-card ourwork-card-content ourwork-card-content1"
            onClick={() => navigate("/courses")}
            style={{ cursor: "pointer" }}
          >
            <h3>Learn Anytime with Simple Online Video Courses</h3>
            <p>
              Learn anytime with simple online video courses that help you
              grow your skills at your own pace.
            </p>
            <div class="ourwork-cta">
              <span>Join Now</span>
              <div class="ourwork-cta-img">
                <img src="assets/images/right_arrow.svg" alt=""/>
              </div>
            </div>
          </div>

         
          <div class="ourwork-card ourwork-card-image ourwork-card-image2">
            <img src="assets/images/image5213121-7s7-500h.png" alt=""/>
          </div>

          
          <div class="ourwork-card ourwork-card-content ourwork-card-content2">
            <h3>Skill training designed for every subscriber</h3>
            <p>
              Skill training for every subscriber, helping them grow with
              practical lessons and real guidance.
            </p>
            <div class="ourwork-cta">
              <span>Join Now</span>
              <div class="ourwork-cta-img">
                <img src="assets/images/right_arrow.svg" alt=""/>
              </div>
            </div>
          </div>

          
          <div class="ourwork-card ourwork-card-content ourwork-card-content3">
            <h3>Learn at Your Own Pace</h3>
            <p>
              Our platform adapts to your schedule, allowing you to progress
               comfortably while mastering concepts thoroughly.
            </p>
            <div class="ourwork-cta">
              <span>Join Now</span>
              <div class="ourwork-cta-img">
                <img src="assets/images/right_arrow.svg" alt=""/>
              </div>
            </div>
          </div>

        
          <div class="ourwork-card ourwork-card-image ourwork-card-image3">
            <img src="assets/images/rectangle103121-ulve-500h.png" alt=""/>
          </div>

          
          <div class="ourwork-card ourwork-card-content ourwork-card-content4">
            <h3>Live Video Classes with Expert Instructors</h3>
            <p>
              Join interactive live sessions where you can ask questions, clear doubts instantly, and learn in real time.
               Experience classroom-style teaching from anywhere while staying connected with instructors and fellow learners.
            </p>
            <div class="ourwork-cta">
              <span>Join Now</span>
              <div class="ourwork-cta-img">
                <img src="assets/images/right_arrow.svg" alt=""/>
              </div>
            </div>
          </div>

         
          <div class="ourwork-card ourwork-card-image ourwork-card-image4">
            <img src="assets/images/rectangle123121-kigr-500h.png" alt=""/>
          </div>

        </div>
      </div>
      </section>

    { /*Support Your Goals Section */}
    <section class="support-goal">
      <div class="support-goal-inner">

        <div class="support-goal-top">

          <div class="support-goal-content">
            <img class="support-goal-quote" src="/assets/images/gl_sec_dbl_qt.svg" alt="Support goal quote"/>

            <h2 class="support-goal-heading">
              <span class="suprt-goal-hdng-1fst-ln">We understand your needs and</span>
              work closely with you to create<br/>
              thoughtful solutions that truly<br/>
              support your goals
            </h2>

            <div class="support-goal-author">
              <img src="/assets/images/sprt-gl-avatar.svg" alt="Jackson Reed"/>
              <div>
                <strong>Jackson Reed</strong>
                <span>Company Director</span>
              </div>
            </div>
          </div>

          <div class="support-goal-image-wrap">
            <img src="/assets/images/support_goal1.png" alt="Support goal"/>
            <img src="/assets/images/support_goal2.png" alt="Support goal"/>
            <img src="/assets/images/support_goal3.png" alt="Support goal"/>
          </div>

        </div>

        <div class="support-goal-bottom">

          <div class="support-goal-achievement">
            <span class="support-goal-line">
              <img src="/assets/images/achievements_top_img.svg" alt="Line image"/>
            </span>
            <h4>Our key achievements</h4>
            <p>
              Your vision matters. We turn your ideas into impactful visuals that
              inspire, connect with audiences, and beautifully reflect your brand’s
              purpose and story.
            </p>
          </div>

          <div class="support-goal-stats">
            <div class="stat">
              <h3>160+</h3>
              <p>Total videos created for your project</p>
            </div>
            <div class="stat">
              <h3>10+</h3>
              <p>Years of experience you can trust.</p>
            </div>
            <div class="stat">
              <h3>50+</h3>
              <p>Our expert delivers precise, reliable work.</p>
            </div>
          </div>

        </div>

      </div>
    </section>

    {/*Discover our services */}
      <section class="disc-our-srvc">
        <div class="container">
          <div class="section-title">
            <h1>Discover Our Services Designed To Support You</h1>
            <img class="hexagon" src="assets/images/hexagon.svg" alt="Hexagon"/>
          </div>

          <div class="our-srvc-card">
            <div class="our-srvc-text">
              <h2>Create Eye-Catching Visuals From Your Ideas With A Smooth, Simple Process</h2>
              <p>
                No design experience needed—simply share your idea. We transform it into visuals that reflect your style and purpose. 
                Every design is crafted to look clean, refined, and engaging, ensuring your content stands out and leaves a strong, lasting impression.
              </p>
              <a href="#" class="btn">Connect Now</a>
            </div>

            <div class="our-srvc-images">
              <img src="/assets/images/eye_catching.png" alt=""/>
            </div>
          </div>

          <div class="cards">

            <div class="card">
              <div class="card-left">
                <h3>Reach More Students,</h3>
                <p>
                 Grow your audience effortlessly while delivering 
                 structured lessons to students anytime, anywhere.
                </p>
                <a href="#" class="btn">Connect Now</a>
              </div>
              <div class="card-img">
                <img class="" src="/assets/images/reach_more.png" alt="Reach more"/>
              </div>
            </div>

            <div class="card">
              <div class="card-left">
                <h3>Relax — It’s Easy to Learn</h3>
                <p>
                  Experience stress-free learning with clear lessons, structured guidance, and a pace that suits you. 
                  Understanding becomes simple when learning is designed the right way.
                </p>
                <a href="#" class="btn">Connect Now</a>
              </div>
              <div class="card-img">
                <img src="/assets/images/relax.png" alt="Relax"/>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/*Hear from users */}
      <section class="fr-users-sec">
        <div class="fr-container">

          <div class="fr-left">
            <h2>
              Hear From Users<br/>
              Who Trust Our Work
            </h2>

            <img class="hexagon" src="/assets/images/hexagon.svg" alt="Hexagon"/>

            <p>
              Your vision matters. We turn your ideas into impactful visuals
              that inspire, connect with audiences, and beautifully reflect
              your brand’s purpose and story.
            </p>
          </div>

          <div class="fr-right">

            <div class="fr-card">
              <img class="fr-quote" src="/assets/images/quote.svg" alt="Quote"/>
              <p>
                Working with the team was effortless. They understood our
                vision, delivered elevated visuals, and impressed us with
                their creativity and attention to detail.
              </p>

              <div class="fr-user">
                <img src="/assets/images/avatar1.jpg" alt="Avatar1"/>
                <div>
                  <h4>Chandra Raj</h4>
                  <span>Director</span>
                </div>
              </div>
            </div>

            <div class="fr-card">
              <img class="fr-quote" src="/assets/images/quote.svg" alt="Quote"/>
              <p>
                Professional, reliable, and talented—their designs told our
                story beautifully, connected instantly with our audience,
                and ensured we’ll collaborate again.
              </p>

              <div class="fr-user">
                <img src="/assets/images/avatar2.jpg" alt="Avatar2"/>
                <div>
                  <h4>Shikha Sen</h4>
                  <span>Visual Creator</span>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/*Loved By Our Customers */}
      <section class="loved-customers-sec">
        <div class="loved-container">

          <div class="loved-left">
            <h2>
              Loved By Our<br/>
              Customers <span class="sparkle">✦</span>
            </h2>

            <p>
              Your vision deserves to stand out. We collaborate closely to
              transform your ideas into powerful visuals that connect,
              inspire, and drive results. From concept to creation, our team
              ensures every detail reflects your brand’s purpose and brings
              your story to life beautifully.
            </p>
          </div>

          <div class="loved-right">
            <form>
              <input type="email" placeholder="Enter your email"/>
              <textarea placeholder="Explain your idea in brief"></textarea>
              <button type="submit">Submit Request</button>
            </form>
          </div>

        </div>
      </section>
      

      {/* Footer */}
      <footer className="site-footer-sec">
        <div className="footer-container">
          <div className="footer-left">
            <h3 className="footer-logo">Vidify</h3>
            <p>© 2026 All Rights Reserved</p>
          </div>

          <ul className="footer-links">
            <li><a href="#services">Services</a></li>
            <li><a href="#case-studies">Case Studies</a></li>
            <li><a href="#contact">Contact</a></li>
          </ul>
        </div>
      </footer>

    </div>
  );
}
